import * as Sentry from '@sentry/react';

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;

export const initSentry = () => {
  Sentry.init({
    dsn: sentryDsn,
    enabled: Boolean(sentryDsn) && process.env.NODE_ENV !== 'development',
    environment: process.env.REACT_APP_SENTRY_ENV || process.env.REACT_APP_APP_ENV || process.env.NODE_ENV,
    tracesSampleRate: 0,
    sendDefaultPii: false,

    // The carousel handles customer and commerce data. Keep automatic
    // collection minimal. Sentry is reserved for application crashes.
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: {
        request: false,
        response: false,
      },
      httpBodies: [],
      urlQueryParams: false,
      graphQL: {
        document: false,
        variables: false,
      },
      genAI: {
        inputs: false,
        outputs: false,
      },
      databaseQueryData: false,
      stackFrameVariables: false,
    },
  });
};
